import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/dobAttachmentActions'
import * as api from '../../api/job/dobAttachments'

function* fetchDobFolders(action) {
  try {
    const payload = yield call(api.fetchDobFolders, action.jobId)
    yield put({ type: constants.DOB_FOLDERS_FETCH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DOB_FOLDERS_FETCH.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchDobFolders() {
  yield takeLatest(constants.DOB_FOLDERS_FETCH.ACTION, fetchDobFolders)
}

function* sagaCreateDobFolder(action) {
  try {
    const payload = {
      job_id: action.jobId,
      name: action.name
    }
    yield call(api.createDobFolder, payload)
    yield put({ type: constants.DOB_FOLDER_CREATE.SUCCESS, payload })
    yield call(fetchDobFolders, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DOB_FOLDER_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateDobFolder() {
  yield takeLatest(constants.DOB_FOLDER_CREATE.ACTION, sagaCreateDobFolder)
}

function* sagaDeleteDobFolder(action) {
  try {
    yield call(api.deleteDobFolder, action.dobAttachmentFolderId)
    yield put({ type: constants.DOB_FOLDERS_DELETE.SUCCESS })
    yield call(fetchDobFolders, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DOB_FOLDERS_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteDobFolder() {
  yield takeLatest(constants.DOB_FOLDERS_DELETE.ACTION, sagaDeleteDobFolder)
}

function* sagaUpdateDobFolder(action) {
  try {
    const payload = {
      job_id: action.jobId,
      name: action.name,
      dobAttachmentFolderId: action.dobAttachmentFolderId
    }
    yield call(api.updateDobFolder, payload)
    yield put({ type: constants.DOB_FOLDERS_UPDATE.SUCCESS, payload })
    yield call(fetchDobFolders, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DOB_FOLDERS_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateDobFolder() {
  yield takeLatest(constants.DOB_FOLDERS_UPDATE.ACTION, sagaUpdateDobFolder)
}

// ATTACHMENT SAGAS
function* uploadDobFolderAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      dobAttachmentFolderId: action.dobAttachmentFolderId
    }

    yield call(api.uploadDobFolderAttachments, payload)
    yield put({ type: constants.UPLOAD_DOB_FOLDER_ATTACHMENT.SUCCESS, payload })
    yield call(getDobFolderAttachments, { dobAttachmentFolderId: action.dobAttachmentFolderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_DOB_FOLDER_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadDobFolderAttachments() {
  yield takeLatest(constants.UPLOAD_DOB_FOLDER_ATTACHMENT.ACTION, uploadDobFolderAttachments)
}

function* getDobFolderAttachments(action) {
  try {
    const payload = yield call(api.getDobFolderAttachments, action.dobAttachmentFolderId)
    yield put({ type: constants.GET_DOB_FOLDER_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_DOB_FOLDER_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetDobFolderAttachments() {
  yield takeLatest(constants.GET_DOB_FOLDER_ATTACHMENTS.ACTION, getDobFolderAttachments)
}

function* updateDobFolderAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_DOB_FOLDER_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getDobFolderAttachments, { dobAttachmentFolderId: action.dobAttachmentFolderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_DOB_FOLDER_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateDobFolderAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_DOB_FOLDER_ATTACHMENT_DESCRIPTION.ACTION,
    updateDobFolderAttachmentDescription
  )
}

function* deleteDobFolderAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      dobAttachmentFolderId: action.dobAttachmentFolderId
    }

    yield call(api.deleteDobFolderAttachment, payload)
    yield put({ type: constants.DELETE_DOB_FOLDER_ATTACHMENT.SUCCESS, payload })
    yield call(getDobFolderAttachments, { dobAttachmentFolderId: action.dobAttachmentFolderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_DOB_FOLDER_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteDobFolderAttachments() {
  yield takeLatest(constants.DELETE_DOB_FOLDER_ATTACHMENT.ACTION, deleteDobFolderAttachment)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchFetchDobFolders),
    fork(watchCreateDobFolder),
    fork(watchDeleteDobFolder),
    fork(watchUpdateDobFolder),

    fork(watchUploadDobFolderAttachments),
    fork(watchGetDobFolderAttachments),
    fork(watchUpdateDobFolderAttachmentDescription),
    fork(watchDeleteDobFolderAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/dobAttachmentSaga.js